module.exports = __webpack_public_path__ + "img/zhuyi@3x.4a3525e8.png";